import React, { SyntheticEvent } from 'react';
import { useStyles } from './AutocompleteAsync.styles';
import { Field, FormikProps } from 'formik';
import { Autocomplete, TextField, TextFieldProps } from '@mui/material';

interface Props {
  value: string[];
  name: string;
  handleChange: (fieldName: string, newValue: string[]) => void;
  options: string[];
  label: string;
}

export const AutocompleteAsync: React.FC<Props> = ({ value, name, handleChange, options, label }) => {
  const styles = useStyles();

  return (
    <Field
      name={name}
      component={Autocomplete}
      multiple
      value={value}
      onChange={(_: SyntheticEvent, newValue: string[]) => handleChange(name, newValue)}
      options={options}
      disableClearable
      limitTags={1}
      renderInput={(params: FormikProps<TextFieldProps>) => (
        <TextField {...params} className={styles.textField} label={label} />
      )}
    />
  );
};
